import { useSelector } from 'react-redux';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILink from 'UIComponents/link/UILink';
import CoreFeaturedCallout from 'marketplace-ui-common/callouts/components/FeaturedCallout';
import { FEATURED_CALLOUT_LAYOUT_TYPES } from 'marketplace-ui-common/callouts/constants/FeaturedCallouts';
import { useFeaturedCallouts } from 'marketplace-ui-common/callouts/hooks/useFeaturedCallouts';
import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import { useIsMaxScreenSize } from 'marketplace-ui-common/hooks/useScreenSize';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { getIsInApp } from '../../selectors/app';
import { getPublicMKPLUrl, getThemesStorefrontRoute } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
function FeaturedCallout({
  callout,
  layout,
  onTrackInteraction
}) {
  var _collection$published;
  const {
    id,
    publishedListing
  } = callout;
  const {
    collectionId,
    externalUrl
  } = publishedListing;
  const isInApp = useSelector(getIsInApp);
  const {
    getCollectionById
  } = usePublishedCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const collection = collectionId ? getCollectionById(collectionId) : null;
  const collectionSlug = collection === null || collection === void 0 || (_collection$published = collection.publishedListing) === null || _collection$published === void 0 ? void 0 : _collection$published.slug;

  /**
   * Following logic will check for Public MKPL `externalUrl` in callout CTA and if so:
   * Will keep redirect if we are in In-App MKPL to guarantee smooth routing behaviour
   */
  const publicMKPLUrl = getPublicMKPLUrl();
  const isPublicMKPLUrl = externalUrl === null || externalUrl === void 0 ? void 0 : externalUrl.startsWith(publicMKPLUrl);
  const isExternalLinkProp = !!externalUrl && !isPublicMKPLUrl;
  const LinkComponent = isExternalLinkProp ? UILink : UIRouterLink;
  const link = collectionSlug ? getThemesStorefrontRoute(collectionSlug) : isPublicMKPLUrl ? externalUrl === null || externalUrl === void 0 ? void 0 : externalUrl.replace(publicMKPLUrl, '') : externalUrl;
  const linkProps = isExternalLinkProp ? {
    href: link
  } : {
    to: link
  };
  if (!link) return null;
  return /*#__PURE__*/_jsx(CoreFeaturedCallout, {
    buttonText: /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.buttonText,
      WrapperComponent: "span"
    }),
    description: /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.description,
      WrapperComponent: "span"
    }),
    headline: /*#__PURE__*/_jsx(SanitizedText, {
      body: publishedListing.headline,
      WrapperComponent: "span"
    }),
    gradientColor: publishedListing.gradientColor,
    illustrationName: publishedListing.illustration,
    layout: layout,
    Link: LinkComponent,
    linkProps: linkProps,
    onClick: () => {
      onTrackInteraction('click featured callout', {
        section: `featured-callout::${id}::static`
      });
    },
    external: isExternalLinkProp,
    responsive: true
  });
}
export default function CalloutsSection({
  onTrackInteraction
}) {
  const isInApp = useSelector(getIsInApp);
  const {
    data: callouts
  } = useFeaturedCallouts({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const isMobile = useIsMaxScreenSize('sm');
  if (callouts.length === 0) return null;
  const isSingleColumn = isMobile || callouts.length === 1;
  const columns = isSingleColumn ? 1 : 2;
  const layout = isSingleColumn ? FEATURED_CALLOUT_LAYOUT_TYPES.FULL_WIDTH : FEATURED_CALLOUT_LAYOUT_TYPES.MULTI;
  return /*#__PURE__*/_jsx(UICardGrid, {
    columns: columns,
    className: "p-top-8 m-top-8 p-bottom-0",
    children: callouts.map(callout => /*#__PURE__*/_jsx(FeaturedCallout, {
      callout: callout,
      layout: layout,
      onTrackInteraction: onTrackInteraction
    }, callout.id))
  });
}